import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { LaunchpoolStatus } from '@flipster/apis/v1/launchpool/types';
import { CurrencyDisplay } from '@flipster/features/src/misc/display';
import { launchpoolItemBunja } from '@flipster/features/src/shared/launchpool/state';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import useStakeFlow from './useStakeFlow';

const CurrencyInfo = () => {
  const t = useTranslations();
  const { launchpoolItemAtom } = useBunja(launchpoolItemBunja);
  const launchpool = useAtomValue(launchpoolItemAtom);
  const handleClickStake = useStakeFlow();
  const isClosed = launchpool.status === LaunchpoolStatus.Closed;

  return (
    <div className={hstack({ justify: 'space-between', mb: 12, color: 'content.default.level-5' })}>
      <CurrencyDisplay
        currency={launchpool.stakingCurrency}
        icon={<CurrencyDisplay.Icon size={32} space={12} />}
        mainLabel={
          <CurrencyDisplay.Label value='shortName' css={{ textStyle: 'Title/XS', color: 'content.default.level-5' }} />
        }
        subLabel={<p className={css({ textStyle: 'Text/S/Regular' })}>Stake to earn {launchpool.rewardCurrency}</p>}
      />
      {!isClosed && (
        <Button
          hierarchy='primary'
          color='accent'
          size='medium'
          label={t('Autogen_common.r251126.s_Stake')}
          disabled={!launchpool.isStakable}
          onClick={handleClickStake}
          css={{ w: 78 }}
        />
      )}
    </div>
  );
};

export default CurrencyInfo;
